import { Avatar, Grid, Typography } from "@mui/material";
import { MprcLink, MprcListItemTitle } from "components";
import { DashListItemDto } from "generated/CoreApi_v1";
import { Formaters } from "lib/Formaters";
import React from "react";

interface IProps {
    item: DashListItemDto;
    subtitle?: React.ReactNode;
    avatarCircular?: boolean;
    avatar?: React.ReactNode;
    charSign?: string;
    onClickName: (item: DashListItemDto) => void;
    onClickItem: (item: DashListItemDto) => void;
}

export const DashListItem: React.FC<IProps> = (props) => {

    const { item, onClickName, onClickItem, avatarCircular = false, subtitle, charSign, avatar } = props;

    return (
        <Grid width="100%">
            <Grid container justifyContent="center" alignItems={subtitle ? "flex-start" : "center"} spacing={2} wrap="nowrap">
                <Grid>
                    <Typography variant="body1"><b>{item.rowNumber}</b></Typography>
                </Grid>
                <Grid>
                    <MprcLink onClick={() => onClickName(item)}>
                        {
                            avatar
                                ?
                                avatar
                                :
                                <Avatar
                                    variant={avatarCircular ? "circular" : "rounded"}
                                    sx={avatarCircular ? { width: 48, height: 48 } : { width: 70, height: 48 }}
                                    src={item.thumbnailUrl}
                                />
                        }
                    </MprcLink>
                </Grid>
                <Grid width="100%" overflow="hidden" alignItems="center">
                    <Grid container alignItems="center" flexWrap="nowrap" width="100%">
                        <Grid overflow="hidden">
                            <MprcListItemTitle onClick={() => onClickName(item)}>
                                {item.name}
                            </MprcListItemTitle>
                        </Grid>
                    </Grid>
                    {
                        subtitle &&
                        <Grid marginTop={0.5}>
                            <MprcLink onClick={() => onClickItem(item)}>
                                <Typography variant="caption" noWrap component="div" color="highlight">
                                    {subtitle}
                                </Typography>
                            </MprcLink>
                        </Grid>
                    }
                </Grid>
                <Grid>
                    <MprcLink onClick={() => onClickItem(item)}>
                        <Typography variant="body1" color="highlight">
                            <b>{Formaters.localeNumber(item.value)}{charSign}</b>
                        </Typography>
                    </MprcLink>
                </Grid>
            </Grid>
        </Grid>

    );
};